module.exports = __webpack_public_path__ + "img/Flag_of_Argentina.a50e1504.svg";